import React from 'react';

const Loader = (props) => {
	return <div className={"loader" + (props.slim ? "  loader--slim" : "")}><div className="loader-wheel"></div></div>;
}

export default Loader;
